module.exports = __webpack_public_path__ + "frontend/img/icon_user.749970bc.svg";